import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import {
    alertErrorMessage,
    throwSuccessMessage,
} from '../../../../utils/Errors'
import { fetchProductsGroups } from './fetchProductsGroups'
import { getUrlWithVersion } from '../../../../api/api'

export const deleteGroupEntry = createAsyncThunk<
    void,
    { groupId: string | undefined; guid: string },
    ThunkConfig<string>
>('productsSlice/deleteGroupEntry', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { groupId, guid } = args

    try {
        await api.delete(
            getUrlWithVersion(`/groups/${groupId}/entries/${guid}`)
        )
        dispatch(fetchProductsGroups())
        throwSuccessMessage(`Success!`)
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to delete group entry')
    }
})
